import React, { Component } from 'react'
import CardWrapper from 'screens/common/CardWrapper'
import { Grid, Statistic } from 'semantic-ui-react'
import { translate } from 'react-i18next'
import { getFormattedTime } from 'helpers/dataFormatter'


class Summary extends Component {

  render() {
    const { t } = this.props;
    let teams = this.props.summary.raw.teams;
    let skype = this.props.summary.raw.skype;
    let total = this.props.summary.raw.total;

    return (
      <Grid centered padded stackable>
        <Grid.Column width={16}>
          <SummaryGrid {...this.props}
            title={t("Screens.Calls.Summary.AllCallsTitle")}
            doc_count={this.getProp("doc_count",total)}
            count_successful={this.getProp("count_successful",total)}
            total_ms={this.getProp("total_ms",total)}
            max_ms={this.getProp("max_ms",total)}
            median_ms={this.getProp("median_ms",total)}
            show={true}
          />
          <SummaryGrid {...this.props}
            title={t("Screens.Calls.Summary.TeamsCallsTitle")}
            doc_count={this.getProp("doc_count",teams)}
            count_successful={this.getProp("count_successful",teams)}
            total_ms={this.getProp("total_ms",teams)}
            max_ms={this.getProp("max_ms",teams)}
            median_ms={this.getProp("median_ms",teams)}
            show={!(this.getProp("doc_count",teams) === 0 || this.getProp("doc_count",skype) === 0)}
          />
          <SummaryGrid {...this.props}
            title={t("Screens.Calls.Summary.SkypeCallsTitle")}
            doc_count={this.getProp("doc_count",skype)}
            count_successful={this.getProp("count_successful",skype)}
            total_ms={this.getProp("total_ms",skype)}
            max_ms={this.getProp("max_ms",skype)}
            median_ms={this.getProp("median_ms",skype)}
            show={!(this.getProp("doc_count",teams) === 0 || this.getProp("doc_count",skype) === 0)}
          />
        </Grid.Column>
      </Grid>
    );
  }

  getProp(key,prop) {
    return prop ? (prop[key] && !isNaN(prop[key]) ? prop[key] : 0) : 0;
  }
}


class SummaryGrid extends Component {
  statSize = "small";
  colWidth = 4

  pad(t) {
    if (t < 10) {
      return "0" + t;
    }
    return "" + t;
  }

  render() {
    const { t } = this.props;
    if (!this.props.show) {
      return null;
    }
    return (
      <Grid centered padded stackable>
        <Grid.Column width={16}>
          <h2>{this.props.title}</h2>
        </Grid.Column>
        <Grid.Column width={this.colWidth}>
          <CardWrapper
            isLoading = {this.props.summary.loading}
          >
            <div style={{textAlign: "center"}}>
              <Statistic 
                label={t("Screens.Calls.Summary.SummaryRow.Calls")}
                value={this.props.doc_count} 
                size={this.statSize} 
              />
            </div>
          </CardWrapper>
        </Grid.Column>
        <Grid.Column width={this.colWidth}>
          <CardWrapper
            isLoading = {this.props.summary.loading}
          >
            <div style={{textAlign: "center"}}>
              <Statistic 
                label={
                  t("Screens.Calls.Summary.SummaryRow.Total") + 
                  '('+getFormattedTime(this.props.total_ms)[1]+')'
                } 
                value={getFormattedTime(this.props.total_ms)[0]} 
                size={this.statSize} 
              />
            </div>
          </CardWrapper>
        </Grid.Column>
        <Grid.Column width={this.colWidth}>
          <CardWrapper
            isLoading = {this.props.summary.loading}
          >
            <div style={{textAlign: "center"}}>
              <Statistic 
                label={ 
                  t("Screens.Calls.Summary.SummaryRow.Median") + 
                  '('+getFormattedTime(this.props.median_ms)[1]+')'
                } 
                value={getFormattedTime(this.props.median_ms)[0]} 
                size={this.statSize} 
              />
            </div>
          </CardWrapper>
        </Grid.Column>
        <Grid.Column width={this.colWidth}>
          <CardWrapper
            isLoading = {this.props.summary.loading}
          >
            <div style={{textAlign: "center"}}>
              <Statistic 
                label={
                  t("Screens.Calls.Summary.SummaryRow.Max") + 
                  '('+getFormattedTime(this.props.max_ms)[1]+')'
                } 
                value={getFormattedTime(this.props.max_ms)[0]} 
                size={this.statSize} 
              />
            </div>
          </CardWrapper>
        </Grid.Column>
      </Grid>
    );
  }
};

export default translate()(Summary);
